/**
 * Theme composable. Two modes per the 2026-05-05 stakeholder decision:
 *   - "light" (default if nothing stored)
 *   - "dark"
 *
 * The `data-theme` attribute on `<html>` is the single source of truth.
 */
import { ref, watch } from "vue";

export type Theme = "light" | "dark";

const STORAGE_KEY = "ram-theme";

function readStoredMode(): Theme {
  const stored = localStorage.getItem(STORAGE_KEY);
  return stored === "dark" ? "dark" : "light";
}

const mode = ref<Theme>(readStoredMode());

watch(
  mode,
  (theme) => {
    document.documentElement.setAttribute("data-theme", theme);
    localStorage.setItem(STORAGE_KEY, theme);
  },
  { immediate: true },
);

export function useTheme() {
  function setMode(next: Theme) {
    mode.value = next;
  }
  function toggle() {
    mode.value = mode.value === "light" ? "dark" : "light";
  }
  return { mode, setMode, toggle };
}
